import { render, staticRenderFns } from "./DocumentsProof.vue?vue&type=template&id=3e09313a&"
import script from "./DocumentsProof.vue?vue&type=script&lang=js&"
export * from "./DocumentsProof.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsProof.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports